import { useReducer } from "react"
import { inc } from "~/shared/lib/utils"

/**
 * Имитация `forceUpdate`
 * @hook
 * @category Hook
 */
export function useForceUpdate() {
	return useReducer(inc, 0)[1]
}
